import axios from 'axios'
import config from '../config'

export default {

    getSpamDomainsList(currentPage, perPage, search) {
        return axios.get(config.publicPath + 'mail_provider_domains', {
            params: {_page: currentPage, itemsPerPage: perPage, domain: search, isBlacklisted: 1},
            headers: {
                'Content-Type': 'application/json'
            }
        });
    },
    addSpamDomains(formData) {
        return axios.post(config.publicPath + 'add-spam-domains', formData, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            validateStatus: function (status) {
                return status >= 200 && status < 500;
            },
        });
    },
    addSpamDomain(domain) {
        return axios.post(config.publicPath + 'add-spam-domain', {domain: domain}, {
            headers: {
                'Content-Type': 'application/json'
            },
            validateStatus: function (status) {
                return status >= 200 && status < 500;
            }
        });
    },
    getSpamDomain(id) {
        return axios.get(config.publicPath + 'mail_provider_domains/' + id);
    },
    deleteSpamDomain(id) {
        return axios.post(config.publicPath + 'remove-spam-domain', {domainId: id}, {
            headers: {
                'Content-Type': 'application/json'
            },
            validateStatus: function (status) {
                return status >= 200 && status < 500;
            }
        });
    }
}
